import { AlertTriangle, X } from 'lucide-react'
import { Button } from './Button'

interface ConfirmDialogProps {
  open: boolean
  title: string
  description: string
  confirmLabel: string
  danger?: boolean
  loading?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function ConfirmDialog(props: ConfirmDialogProps) {
  if (!props.open) return null
  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget && !props.loading) props.onCancel()
    }}>
      <section className="confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-description">
        <header>
          <span className="dialog-warning"><AlertTriangle aria-hidden="true" /></span>
          <div>
            <h2 id="confirm-title">{props.title}</h2>
            <p id="confirm-description">{props.description}</p>
          </div>
          <button className="icon-button" type="button" aria-label="Fechar" title="Fechar" disabled={props.loading} onClick={props.onCancel}>
            <X />
          </button>
        </header>
        <footer>
          <Button type="button" onClick={props.onCancel} disabled={props.loading}>Cancelar</Button>
          <Button type="button" variant={props.danger ? 'danger' : 'primary'} loading={props.loading} onClick={props.onConfirm}>
            {props.confirmLabel}
          </Button>
        </footer>
      </section>
    </div>
  )
}
